module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_7005.f1557489.png";